<div mat-dialog-content class="loan-status-details">
    <h4>Loan Status Details</h4>
    <p>{{data?.loanNumber}}  | {{data?.updatedTime | date: 'MM/dd/YYYY' }}</p>

    <div class="Vert-15"></div>
    <h5>Loan Details</h5>

    <ng-container *ngFor="let status of data?.loanStatuses">
        <div class="loan-detail">
            <span class="status-name">{{status?.name}}</span>
            <span class="status-date">{{status?.date | date: 'MM/dd/YYYY HH:mm'}}</span>
        </div>
    </ng-container>
    

    <mat-dialog-actions class="dialog-actions" align="end">
        <button *ngIf="data.woCancelButton!=true" mat-stroked-button class="btn btn-secondary"
            (click)="dialogRef.close()">Close</button>
    </mat-dialog-actions>
    </div>